import Stack from "@mui/material/Stack";

const ButtonToolbar = ({children, spacing = 2}) => {
    return (
        <Stack
            direction="row"
            spacing={spacing}
            sx={{
                padding: 0,
                borderTop: "1px solid #e0e0e0",
                marginTop: 0,
            }}
        >
            {children}
        </Stack>
    );
};

export default ButtonToolbar;
